<template>
  <div class="register">
    <div class="content">
      <div class="glass"></div>
      <div class="info">
        <div class="info_left">
          <img src="../assets/img/login_illustration.png" alt="">
        </div>
        <div class="info_right">
          <h2>Merry Home Fashion</h2>
          <div class="operating">
            <p v-if="errors.length" style='padding-bottom: 20px'>
              <b>{{ $t('followingErrors') }}</b>
              <ul style="color: red">
                <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
              </ul>
            </p>
            <div class="input_box">
              <img src="../assets/img/login_1.png" alt="">
              <el-input v-model="formRegister.FirstName" :placeholder="$t('firstName')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_1.png" alt="">
              <el-input v-model="formRegister.LastName" :placeholder="$t('lastName')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_1.png" alt="">
              <el-input v-model="formRegister.username" :placeholder="$t('userName')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_3.png" alt="">
              <el-input v-model="formRegister.email" :placeholder="$t('email')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_3.png" alt="">
              <el-input v-model="formRegister.phone" :placeholder="$t('phone')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_2.png" alt="">
              <el-input v-model="formRegister.password" :placeholder="$t('password')"></el-input>
            </div>
            <!-- invite code hidden -->
            <!-- <div class="input_box">
              <img src="../assets/img/login_1.png" alt="">
              <el-input v-if='hasInviteCode' :value="$t('invite_code')" :disabled="hasInviteCode" :placeholder="$t('invite_code')"></el-input>
              <el-input v-model="formRegister.recommender" :disabled="hasInviteCode" :placeholder="$t('invite_code')"></el-input>
            </div> -->
            <el-button class="reg_btn" @click="register(formRegister)">{{ $t('create') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Router from '../router'
export default {
  name: "register",
    props: {
    inviteCode: {
      type: String,
    },
  },
  data() {
    return {
      hasInviteCode: false,
      errors: [],
      labelPosition: 'top',
      formRegister: {
        FirstName: '',
        LastName: '',
        email: '',
        phone: '',
        password:'',
        username: '',
        recommender: '',
      }
    }
  },
  methods: {
    ...mapActions('auth', ['registerRequest', 'checkUsername', 'checkEmail', 'checkRecommender', 'LoginRequest']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone: function (phone) {
      var re = /^[0-9]*$/;
      return re.test(phone);
    },
    checkForm: async function (form) {
      this.errors = [];
      const usernameBeenTaken = await this.checkUsername({ username: form.username });
      var recommenderInvalid = null;
      if (form.recommender) {
        recommenderInvalid = await this.checkRecommender({ recommender: form.recommender });
      }
      if(!form.FirstName) {
      this.errors.push(this.$t('firstNameRequired'))
      };
      if(!form.LastName) {
        this.errors.push(this.$t('lastNameRequired'))
      };
      if(form.password.length < 8) {
        this.errors.push(this.$t('passwordLengthRequired'))
      };
      if(form.username.length < 5) {
        this.errors.push(this.$t('usernameLengthRequired'));
      };
      if(usernameBeenTaken.data.isTaken) {
        this.errors.push(this.$t('usernameTaken'))
      };
      if(recommenderInvalid && recommenderInvalid.data.isTaken) {
        this.errors.push(this.$t('recommenderInvalid'));
      };
      // if(!form.phone) {
      //   this.errors.push(this.$t('phoneRequired'))
      // }
      if (!this.validPhone(form.phone)) {
          this.errors.push(this.$t('phoneInvalid'))
      }
      if (!form.email) {
        this.errors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.email)) {
        this.errors.push(this.$t('emailValidRequired'));
      }else {
        const res = await this.checkEmail({ email: form.email })
        if(res.data.isTaken) {
          this.errors.push(this.$t('emailTaken'))
        }
      }        
    },
    register: async function(form) {
      await this.checkForm(form);
      if(!this.errors.length) {
        this.registerRequest(form)
        .then(res => {
          this.LoginRequest({username: form.username, password: form.password});
        })
        .catch( err => {
          this.errors = [];
          this.errors.push(this.$t('errorCreateAccount'));
        })
      }
    }
  },
    mounted() {
      let savedCode = "";
      if (this.inviteCode) {
        localStorage.setItem('inviteCodeStore', this.inviteCode);
        this.formRegister.recommender = this.inviteCode;
        this.hasInviteCode = true;
      } else if (localStorage.getItem('inviteCodeStore')) {
        savedCode = localStorage.getItem('inviteCodeStore'); 
        this.formRegister.recommender = savedCode;
        this.hasInviteCode = true;
      }
    },
  computed: mapState({
    errorMessage: state => state.auth.registerErrorMessage
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/register.less";
</style>



// WEBPACK FOOTER //
// src/view/register.vue